import { AfterViewInit, Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService implements AfterViewInit {
  users: any[] = [];
  filteredUsers: any[] = [];

  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore) {}

  ngAfterViewInit(): void {
    /*this.getAllApprovedUsers().subscribe((data: any) => {
      this.users = data;
      console.log('88888888888888888888', this.users);
    })*/
  }

  currentUser: any;
  getCurrentUser() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.afs
          .collection('users')
          .doc(user.uid)
          .valueChanges()
          .subscribe((user) => {
            this.currentUser = user;
            console.log('ZZZZZZZZSSSSSSSSSSSS',this.currentUser);
          });
      }
    });
  }

  getAllApprovedUsers(): Observable<any[]> {
    return this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          const companyOrSoloProviderQuery = this.afs
            .collection('users', (ref) =>
              ref
                .where('role', 'in', ['company', 'solosp', 'cprovider'])
                .where('isApproved', '==', true)
            )
            .snapshotChanges();

          const customerQuery = this.afs
            .collection('users', (ref) => ref.where('role', '==', 'customer'))
            .snapshotChanges();

          return combineLatest([
            companyOrSoloProviderQuery,
            customerQuery,
          ]).pipe(
            map(([companyOrSoloActions, customerActions]: any[]) => [
              ...companyOrSoloActions.map((a: any) => {
                const data = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
              }),
              ...customerActions.map((a: any) => {
                const data = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
              }),
            ])
          );
        } else {
          return of([]);
        }
      })
    );
  }

  getAllUnapprovedUsers(): Observable<any[]> {
    return this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.afs
            .collection('users', (ref) => ref.where('isApproved', '==', false))
            .snapshotChanges()
            .pipe(
              map((actions: any) =>
                actions.map((a: any) => {
                  const data = a.payload.doc.data();
                  const id = a.payload.doc.id;
                  return { id, ...data };
                })
              )
            );
        } else {
          return of([]);
        }
      })
    );
  }

  /** Companies and solo providers awaiting approval (`isApproved === false`). */
  getCompaniesAndProviders(): Observable<any[]> {
    return this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.afs
            .collection('users', (ref) =>
              ref
                .where('role', 'in', ['company', 'solosp'])
                .where('isApproved', '==', false)
            )
            .snapshotChanges()
            .pipe(
              map((actions: any) =>
                actions.map((a: any) => {
                  const data = a.payload.doc.data();
                  const id = a.payload.doc.id;
                  return { id, ...data };
                })
              )
            );
        } else {
          return of([]);
        }
      })
    );
  }
}
